/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Approveprospectlist3Inputs */

const en_coinvestments_approveprospectlist3 = /** @type {(inputs: Coinvestments_Approveprospectlist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve Prospect List`)
};

/**
* | output |
* | --- |
* | "Approve Prospect List" |
*
* @param {Coinvestments_Approveprospectlist3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_approveprospectlist3 = /** @type {((inputs?: Coinvestments_Approveprospectlist3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Approveprospectlist3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_approveprospectlist3(inputs)
});
export { coinvestments_approveprospectlist3 as "coInvestments_approveProspectList" }